import { render } from "./MessaggioGlobale.vue?vue&type=template&id=ebbceb50&scoped=true"
import script from "./MessaggioGlobale.vue?vue&type=script&lang=js"
export * from "./MessaggioGlobale.vue?vue&type=script&lang=js"

import "./MessaggioGlobale.vue?vue&type=style&index=0&id=ebbceb50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebbceb50"]])

export default __exports__